<template>
 <div id="app">
  <div class="form__field">
   <div class="cell">
    <input @keyup.enter="queryResults" class="ids_topicSearch" id="ctl00_ids_contentPlaceHolder_ids_topicSearch" name="ctl00$ids_contentPlaceHolder$ids_topicSearch" placeholder="Search Contents" type="text" v-model="search"/>
   </div>
   <div class="search_button" v-if="search">
    <button @click="clearResult" class="close-icon">
     &times;
    </button>
   </div>
   <div class="search_button">
    <button @click="queryResults">
     <i class="fa fa-search">
     </i>
    </button>
   </div>
  </div>
  <div class="col-1 l-pad-top" id="results">
   <div>
    <p class="toc-2-style" style="margin-bottom: 10px;">
     <strong v-if="resultsCount != 0">
      ({{resultsCount}}) Results Found
     </strong>
     <strong v-else-if="resultsActual">
      No Results Found
     </strong>
    </p>
   </div>
   <div v-for="result of resultsActual">
    <p class="toc-2-style">
     <a :href="result.link" :keywords="result.keywords" onclick="reload(this.href, this.getAttribute('keywords'))">
      {{result.title}}
     </a>
    </p>
    <p class="toc-3-style">
     {{result.desc}}
    </p>
   </div>
  </div>
  <div class="side-toc" v-if="!resultsActual">
   <p class="toc-1-style">
    <a href="cover.html" title="MX910 系列">
     MX910 系列
    </a>
   </p>
   <p class="toc-1-style">
    <a href="safety.html#safety_sc" title="安全信息">
     安全信息
    </a>
   </p>
   <div id="divd0e18">
   </div>
   <p class="toc-1-style">
    <a href="learning-about-printer-chapter.html#learning-about-printer-chapter_sc" title="了解打印机">
     了解打印机
    </a>
   </p>
   <div id="divd0e154">
    <p class="toc-2-style">
     <a href="finding-information-about-printer-topic.html#finding-information-about-printer_sc" title="查找有关打印机的信息">
      查找有关打印机的信息
     </a>
    </p>
    <p class="toc-2-style">
     <a href="connecting-the-printer-to-outlet-topic.html#connecting-the-printer-to-outlet_sc" title="将打印机连接到电源插座">
      将打印机连接到电源插座
     </a>
    </p>
    <p class="toc-2-style">
     <a href="selecting-location-printer-m-topic.html#selecting-location-printer-m_sc" title="为打印机选择位置">
      为打印机选择位置
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printer-configurations-topic.html#printer-configurations_sc" title="打印机配置">
      打印机配置
     </a>
    </p>
    <p class="toc-2-style">
     <a href="understanding-basic-functions-scanner-topic.html#understanding-basic-functions-scanner_sc" title="理解扫描仪的基本功能">
      理解扫描仪的基本功能
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-ADF-and-scanner-glass-topic.html#using-ADF-and-scanner-glass_sc" title="使用 ADF 和扫描仪玻璃">
      使用 ADF 和扫描仪玻璃
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="understanding-home-screen-chapter.html#understanding-home-screen-chapter_sc" title="理解打印机控制面板">
     理解打印机控制面板
    </a>
   </p>
   <div id="divd0e597">
    <p class="toc-2-style">
     <a href="using-printer-control-panel-topic.html#using-printer-control-panel_sc" title="使用控制面板">
      使用控制面板
     </a>
    </p>
    <p class="toc-2-style">
     <a href="understanding-colors-sleep-button-indicator-lights-h-topic.html#understanding-colors-sleep-button-indicator-lights-h_sc" title="理解&ldquo;睡眠&rdquo;按钮和指示灯的颜色">
      理解&ldquo;睡眠&rdquo;按钮和指示灯的颜色
     </a>
    </p>
    <p class="toc-2-style">
     <a href="understanding-home-screen-topic.html#understanding-home-screen_sc" title="理解主屏幕">
      理解主屏幕
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-touch-screen-buttons-topic.html#using-touch-screen-buttons_sc" title="使用触摸屏按钮">
      使用触摸屏按钮
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="setting-up-using-home-screen-apps-chapter.html#setting-up-using-home-screen-apps-chapter_sc" title="设置和使用主屏幕应用程序">
     设置和使用主屏幕应用程序
    </a>
   </p>
   <div id="divd0e1129">
    <p class="toc-2-style">
     <a href="finding-ip-address-of-printer-topic.html#finding-ip-address-of-printer_sc" title="查找打印机的 IP 地址">
      查找打印机的 IP 地址
     </a>
    </p>
    <p class="toc-2-style">
     <a href="finding-ip-address-of-computer-topic.html#finding-ip-address-of-computer_sc" title="查找计算机的 IP 地址">
      查找计算机的 IP 地址
     </a>
    </p>
    <p class="toc-2-style">
     <a href="accessing-embedded-web-server-topic.html#accessing-embedded-web-server_sc" title="访问 Embedded Web Server">
      访问 Embedded Web Server
     </a>
    </p>
    <p class="toc-2-style">
     <a href="customizing-home-screen-topic.html#customizing-home-screen_sc" title="定制主屏幕">
      定制主屏幕
     </a>
    </p>
    <p class="toc-2-style">
     <a href="understanding-different-apps-topic.html#understanding-different-apps_sc" title="理解不同的应用程序">
      理解不同的应用程序
     </a>
    </p>
    <p class="toc-2-style">
     <a href="activating-home-screen-apps-group.html#activating-home-screen-apps-title_sc" title="激活主屏幕应用程序">
      激活主屏幕应用程序
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-remote-operator-panel-topic.html#setting-up-remote-operator-panel_sc" title="设置&ldquo;远程操作面板&rdquo;">
      设置&ldquo;远程操作面板&rdquo;
     </a>
    </p>
    <p class="toc-2-style">
     <a href="exporting-importing-configuration-using-ews-winners-circle-topic.html#exporting-importing-configuration-using-ews-winners-circle_sc" title="导出和导入配置">
      导出和导入配置
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="installing-options-chapter.html#installing-options-chapter_sc" title="其他打印机设置">
     其他打印机设置
    </a>
   </p>
   <div id="divd0e1762">
    <p class="toc-2-style">
     <a href="internal-options.html#internal-options_sc" title="安装内置式选件">
      安装内置式选件
     </a>
    </p>
    <p class="toc-2-style">
     <a href="order-installation-topic.html#d0e2058" title="安装硬件选件">
      安装硬件选件
     </a>
    </p>
    <p class="toc-2-style">
     <a href="attaching-cables-topic.html#attaching-cables_sc" title="连接电缆">
      连接电缆
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-printer-software-topic.html#d0e2314" title="设置打印机软件">
      设置打印机软件
     </a>
    </p>
    <p class="toc-2-style">
     <a href="preparing-set-up-printer-ethernet-network-topic.html#d0e2383" title="网络连接">
      网络连接
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-menu-settings-page-h2-topic.html#d0e2748" title="检验打印机设置">
      检验打印机设置
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="loading-paper-and-specialty-media-chapter.html#loading-paper-and-specialty-media-chapter_sc" title="加载纸张和特殊介质">
     加载纸张和特殊介质
    </a>
   </p>
   <div id="divd0e2794">
    <p class="toc-2-style">
     <a href="setting-paper-size-and-type-topic.html#setting-paper-size-and-type_sc" title="设置纸张尺寸和类型">
      设置纸张尺寸和类型
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-universal-paper-settings-topic.html#configuring-universal-paper-settings_sc" title="配置 Universal 纸张设置">
      配置 Universal 纸张设置
     </a>
    </p>
    <p class="toc-2-style">
     <a href="loading-trays-topic.html#loading-trays_sc" title="加载进纸匣">
      加载进纸匣
     </a>
    </p>
    <p class="toc-2-style">
     <a href="loading-multipurpose-feeder-h-topic.html#loading-multipurpose-feeder-h_sc" title="加载多功能进纸器">
      加载多功能进纸器
     </a>
    </p>
    <p class="toc-2-style">
     <a href="linking-and-unlinking-trays-h2-topic.html#d0e2974" title="进纸匣连接和解除连接">
      进纸匣连接和解除连接
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="paper-and-specialty-media-guide-chapter.html#paper-and-specialty-media-guide-chapter_sc" title="纸张和特殊介质指南">
     纸张和特殊介质指南
    </a>
   </p>
   <div id="divd0e3093">
    <p class="toc-2-style">
     <a href="using-specialty-media.html#d0e3104" title="使用特殊介质">
      使用特殊介质
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-guidelines-group-title.html#paper-guidelines-group-title_sc" title="纸张使用指南">
      纸张使用指南
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-media-sizes-types-weights-supported.html#paper-media-sizes-types-weights-supported_sc" title="支持的纸张尺寸、类型和重量">
      支持的纸张尺寸、类型和重量
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="printing-chapter.html#printing-chapter_sc" title="打印">
     打印
    </a>
   </p>
   <div id="divd0e5746">
    <p class="toc-2-style">
     <a href="printing-forms-topic.html#d0e5749" title="打印表单和文档">
      打印表单和文档
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-flash-drive-h2-topic.html#d0e5823" title="从闪存驱动器或移动设备打印">
      从闪存驱动器或移动设备打印
     </a>
    </p>
    <p class="toc-2-style">
     <a href="holding-confidential-other-jobs.html#holding-confidential-other-jobs_sc" title="打印保密和其他挂起作业">
      打印保密和其他挂起作业
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-font-sample-list-h2-topic.html#d0e6122" title="打印信息页">
      打印信息页
     </a>
    </p>
    <p class="toc-2-style">
     <a href="canceling-print-job-from-printer-control-panel-h2-topic.html#d0e6167" title="取消打印作业">
      取消打印作业
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="copying.html#copying_sc" title="复印">
     复印
    </a>
   </p>
   <div id="divd0e6211">
    <p class="toc-2-style">
     <a href="copying-using-adf-or-scanner-glass-topic.html#d0e6241" title="制作副本">
      制作副本
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-copy-shortcut-using-printer-control-panel-topic.html#d0e6343" title="创建复印快捷方式">
      创建复印快捷方式
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-to-different-size-topic.html#d0e6400" title="定制复印设置">
      定制复印设置
     </a>
    </p>
    <p class="toc-2-style">
     <a href="placing-header-or-footer-on-pages-topic.html#placing-header-or-footer-on-pages_sc" title="在页面上放置页眉或页脚">
      在页面上放置页眉或页脚
     </a>
    </p>
    <p class="toc-2-style">
     <a href="canceling-copy-job-while-pages-are-being-printed-topic.html#canceling-copy-job-while-pages-are-being-printed_sc" title="当正在打印页面时取消复印作业">
      当正在打印页面时取消复印作业
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copy-from-topic.html#d0e6797" title="理解复印选项">
      理解复印选项
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="E-mailing.html#E-mailing_sc" title="电子邮件">
     电子邮件
    </a>
   </p>
   <div id="divd0e7002">
    <p class="toc-2-style">
     <a href="configuring-email-settings-topic.html#d0e7032" title="设置打印机发送电子邮件">
      设置打印机发送电子邮件
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-email-shortcut-using-ews-topic.html#d0e7060" title="创建电子邮件快捷方式">
      创建电子邮件快捷方式
     </a>
    </p>
    <p class="toc-2-style">
     <a href="sending-email-using-control-panel-topic.html#d0e7154" title="用电子邮件发送文档">
      用电子邮件发送文档
     </a>
    </p>
    <p class="toc-2-style">
     <a href="email-changing-output-file-type-topic.html#d0e7225" title="定制电子邮件设置">
      定制电子邮件设置
     </a>
    </p>
    <p class="toc-2-style">
     <a href="canceling-an-email-topic.html#canceling-an-email_sc" title="取消电子邮件">
      取消电子邮件
     </a>
    </p>
    <p class="toc-2-style">
     <a href="email-recipients-topic.html#d0e7281" title="理解电子邮件选项">
      理解电子邮件选项
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="Faxing.html#Faxing_sc" title="传真">
     传真
    </a>
   </p>
   <div id="divd0e7484">
    <p class="toc-2-style">
     <a href="initial-fax-setup-topic.html#d0e7514" title="设置打印机发送传真">
      设置打印机发送传真
     </a>
    </p>
    <p class="toc-2-style">
     <a href="sending-fax-topic.html#sending-fax_sc" title="发送传真">
      发送传真
     </a>
    </p>
    <p class="toc-2-style">
     <a href="sending-fax-at-scheduled-time-topic.html#sending-fax-at-scheduled-time_sc" title="在预定时间发送传真">
      在预定时间发送传真
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-fax-destination-shortcut-using-embedded-web-server-topic.html#d0e8075" title="创建快捷方式">
      创建快捷方式
     </a>
    </p>
    <p class="toc-2-style">
     <a href="changing-fax-resolution-topic.html#d0e8174" title="定制传真设置">
      定制传真设置
     </a>
    </p>
    <p class="toc-2-style">
     <a href="canceling-fax-job-topic.html#canceling-fax-job_sc" title="取消传真作业">
      取消传真作业
     </a>
    </p>
    <p class="toc-2-style">
     <a href="holding-faxes-topic.html#d0e8302" title="挂起和转发传真">
      挂起和转发传真
     </a>
    </p>
    <p class="toc-2-style">
     <a href="faxing-resolution-topic.html#d0e8403" title="理解传真选项">
      理解传真选项
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="Scanning.html#Scanning_sc" title="扫描">
     扫描
    </a>
   </p>
   <div id="divd0e8549">
    <p class="toc-2-style">
     <a href="using-scan-to-network-topic.html#using-scan-to-network_sc" title="使用&ldquo;扫描到网络&rdquo;">
      使用&ldquo;扫描到网络&rdquo;
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-ftp-shortcuts-using-ews-topic.html#d0e8564" title="扫描到 FTP 地址">
      扫描到 FTP 地址
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-scan-to-computer-topic.html#d0e8726" title="扫描到计算机或闪存驱动器">
      扫描到计算机或闪存驱动器
     </a>
    </p>
    <p class="toc-2-style">
     <a href="ftp-destination-topic.html#d0e8801" title="理解扫描选项">
      理解扫描选项
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="understanding-printer-menus-chapter.html#understanding-printer-menus-chapter_sc" title="理解打印机菜单">
     理解打印机菜单
    </a>
   </p>
   <div id="divd0e8984">
    <p class="toc-2-style">
     <a href="menus-list-topic.html#menus-list_sc" title="菜单列表">
      菜单列表
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-menu-group.html#paper-menu-group_sc" title="纸张菜单">
      纸张菜单
     </a>
    </p>
    <p class="toc-2-style">
     <a href="reports-group.html#reports-group_sc" title="报告菜单">
      报告菜单
     </a>
    </p>
    <p class="toc-2-style">
     <a href="network-ports-group.html#network-ports-group_sc" title="网络/端口菜单">
      网络/端口菜单
     </a>
    </p>
    <p class="toc-2-style">
     <a href="security-menus-group.html#d0e11888" title="安全菜单">
      安全菜单
     </a>
    </p>
    <p class="toc-2-style">
     <a href="settings-group.html#settings-group_sc" title="设置菜单">
      设置菜单
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="conserving-printer-energy-materials.html#conserving-printer-energy-materials_sc" title="节省费用和环境资源">
     节省费用和环境资源
    </a>
   </p>
   <div id="divd0e18100">
    <p class="toc-2-style">
     <a href="conserving-printer-energy-materials.html#d0e18118" title="节省纸张和碳粉">
      节省纸张和碳粉
     </a>
    </p>
    <p class="toc-2-style">
     <a href="conserving-printer-energy-materials.html#d0e18179" title="节省能源">
      节省能源
     </a>
    </p>
    <p class="toc-2-style">
     <a href="conserving-printer-energy-materials.html#d0e18367" title="循环再生">
      循环再生
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="securing-the-printer.html#securing-the-printer_sc" title="保护打印机">
     保护打印机
    </a>
   </p>
   <div id="divd0e18435">
    <p class="toc-2-style">
     <a href="using-security-lock-feature-m-topic.html#using-security-lock-feature-m_sc" title="使用安全锁特性">
      使用安全锁特性
     </a>
    </p>
    <p class="toc-2-style">
     <a href="statement-of-volatility-h-topic.html#statement-of-volatility-h_sc" title="易失性声明">
      易失性声明
     </a>
    </p>
    <p class="toc-2-style">
     <a href="erasing-volatile-memory-h-topic.html#erasing-volatile-memory-h_sc" title="清除易失性内存">
      清除易失性内存
     </a>
    </p>
    <p class="toc-2-style">
     <a href="erasing-non-volatile-memory-h-topic.html#erasing-non-volatile-memory-h_sc" title="清除非易失性内存">
      清除非易失性内存
     </a>
    </p>
    <p class="toc-2-style">
     <a href="erasing-printer-hard-disk-memory-h1-topic.html#erasing-printer-hard-disk-memory-h1_sc" title="清除打印机硬盘内存">
      清除打印机硬盘内存
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-printer-hard-disk-encryption-topic.html#configuring-printer-hard-disk-encryption_sc" title="配置打印机硬盘加密">
      配置打印机硬盘加密
     </a>
    </p>
    <p class="toc-2-style">
     <a href="finding-printer-security-information-b-topic.html#finding-printer-security-information-b_sc" title="查找打印机安全信息">
      查找打印机安全信息
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="maintain-printer-chapter.html#maintain-printer-chapter_sc" title="维护打印机">
     维护打印机
    </a>
   </p>
   <div id="divd0e18672">
    <p class="toc-2-style">
     <a href="cleaning-printer-topic.html#d0e18677" title="清洁打印机部件">
      清洁打印机部件
     </a>
    </p>
    <p class="toc-2-style">
     <a href="checking-status-of-parts-and-supplies-on-printer-control-panel-topic.html#d0e18830" title="检查部件和耗材的状态">
      检查部件和耗材的状态
     </a>
    </p>
    <p class="toc-2-style">
     <a href="estimated-number-remaining-pages-topic.html#estimated-number-remaining-pages_sc" title="估算的剩余页数">
      估算的剩余页数
     </a>
    </p>
    <p class="toc-2-style">
     <a href="ordering-supplies.html#ordering-supplies_sc" title="订购耗材">
      订购耗材
     </a>
    </p>
    <p class="toc-2-style">
     <a href="ordering-maintenance-kit-topic.html#ordering-maintenance-kit_sc" title="订购 300K 维护组件">
      订购 300K 维护组件
     </a>
    </p>
    <p class="toc-2-style">
     <a href="storing-supplies-topic.html#d0e19083" title="存储部件和耗材">
      存储部件和耗材
     </a>
    </p>
    <p class="toc-2-style">
     <a href="replacing-supplies.html#d0e19127" title="更换耗材">
      更换耗材
     </a>
    </p>
    <p class="toc-2-style">
     <a href="replacing-exhaust-ozone-filters-topic.html#d0e19335" title="更换 300K 维护组件">
      更换 300K 维护组件
     </a>
    </p>
    <p class="toc-2-style">
     <a href="replacing-adf-scan-pad-topic.html#replacing-adf-scan-pad_sc" title="更换 ADF 扫描垫">
      更换 ADF 扫描垫
     </a>
    </p>
    <p class="toc-2-style">
     <a href="moving-the-printer.html#moving-the-printer_sc" title="移动打印机">
      移动打印机
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="administrative-support-chapter.html#administrative-support-chapter_sc" title="管理打印机">
     管理打印机
    </a>
   </p>
   <div id="divd0e19678">
    <p class="toc-2-style">
     <a href="checking-virtual-display-h-topic.html#checking-virtual-display-h_sc" title="检查虚拟显示屏">
      检查虚拟显示屏
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-e-mail-alert-topic.html#setting-up-e-mail-alert_sc" title="设置电子邮件警报">
      设置电子邮件警报
     </a>
    </p>
    <p class="toc-2-style">
     <a href="viewing-reports-topic.html#viewing-reports_sc" title="查看报告">
      查看报告
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-printer-settings-to-other-printers-topic.html#copying-printer-settings-to-other-printers_sc" title="将打印机设置复制到其他打印机">
      将打印机设置复制到其他打印机
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-supply-notifications-h2-topic.html#configuring-supply-notifications-h2_sc" title="从 Embedded Web Server 配置耗材通知">
      从 Embedded Web Server 配置耗材通知
     </a>
    </p>
    <p class="toc-2-style">
     <a href="restoring-factory-default-settings-h-topic.html#restoring-factory-default-settings-h_sc" title="还原出厂默认设置">
      还原出厂默认设置
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="clearing-jams-chapter.html#clearing-jams-chapter_sc" title="清除卡纸">
     清除卡纸
    </a>
   </p>
   <div id="divd0e19914">
    <p class="toc-2-style">
     <a href="avoiding-jams-topic.html#avoiding-jams_sc" title="避免卡纸">
      避免卡纸
     </a>
    </p>
    <p class="toc-2-style">
     <a href="understanding-jam-messages-topic.html#understanding-jam-messages_sc" title="理解卡纸消息和位置">
      理解卡纸消息和位置
     </a>
    </p>
    <p class="toc-2-style">
     <a href="message-page-jam-clear-manual-feeder-topic.html#message-page-jam-clear-manual-feeder_sc" title="[x] 页卡住，从多功能进纸器中清除被卡的纸张。[200.xx]">
      [x] 页卡住，从多功能进纸器中清除被卡的纸张。[200.xx]
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-jam-open-door-c-clear-all-jammed-media-topic.html#paper-jam-open-door-c-clear-all-jammed-media_sc" title="[x] 页卡住，打开盖门 C 并清除所有被卡的纸张。[2yy.xx]">
      [x] 页卡住，打开盖门 C 并清除所有被卡的纸张。[2yy.xx]
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-jam-slide-tray-open-door-c-topic.html#paper-jam-slide-tray-open-door-c_sc" title="[x] 页卡住，滑动 3000 页进纸匣并打开盖门 C。[2yy.xx]">
      [x] 页卡住，滑动 3000 页进纸匣并打开盖门 C。[2yy.xx]
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-jam-open-door-d-clear-all-jammed-media-topic.html#paper-jam-open-door-d-clear-all-jammed-media_sc" title="[x] 页卡住，打开盖门 D 并清除所有被卡的纸张。[24y.xx]">
      [x] 页卡住，打开盖门 D 并清除所有被卡的纸张。[24y.xx]
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-jam-slide-tray-open-door-d-topic.html#paper-jam-slide-tray-open-door-d_sc" title="[x] 页卡住，滑动 3000 页进纸匣并打开盖门 D。[24y.xx]">
      [x] 页卡住，滑动 3000 页进纸匣并打开盖门 D。[24y.xx]
     </a>
    </p>
    <p class="toc-2-style">
     <a href="message-page-jam-detach-tray-open-door-f-topic.html#message-page-jam-detach-tray-open-door-f_sc" title="[x] 页卡住，滑动 3000 页进纸匣并打开盖门 F。[24y.xx]">
      [x] 页卡住，滑动 3000 页进纸匣并打开盖门 F。[24y.xx]
     </a>
    </p>
    <p class="toc-2-style">
     <a href="message-page-jam-open-doors-g-h-j-clear-jammed-paper-topic.html#message-page-jam-open-doors-g-h-j-clear-jammed-paper_sc" title="[x] 页卡住，打开盖门 G、H 和 J 并清除被卡的纸张。将纸张留在接纸架中。[4yy.xx]">
      [x] 页卡住，打开盖门 G、H 和 J 并清除被卡的纸张。将纸张留在接纸架中。[4yy.xx]
     </a>
    </p>
    <p class="toc-2-style">
     <a href="message-page-jam-press-latch-to-access-area-g-leave-paper-in-bin-topic.html#message-page-jam-press-latch-to-access-area-g-leave-paper-in-bin_sc" title="[x] 页卡住，按压插销以访问区域 G。将纸张留在接纸架中。[40y.xx]">
      [x] 页卡住，按压插销以访问区域 G。将纸张留在接纸架中。[40y.xx]
     </a>
    </p>
    <p class="toc-2-style">
     <a href="message-page-jam-press-latch-to-access-area-g-clear-jammed-staples-leave-paper-in-bin-topic.html#message-page-jam-press-latch-to-access-area-g-clear-jammed-staples-leave-paper-in-bin_sc" title="[x] 页卡住，按压插销以访问区域 G 并清除被卡的订书钉。将纸张留在接纸架中。[402.93]">
      [x] 页卡住，按压插销以访问区域 G 并清除被卡的订书钉。将纸张留在接纸架中。[402.93]
     </a>
    </p>
    <p class="toc-2-style">
     <a href="message-paper-jam-open-door-h-rotate-knob-h6-clockwise-leave-paper-in-bin-topic.html#message-paper-jam-open-door-h-rotate-knob-h6-clockwise-leave-paper-in-bin_sc" title="[x] 页卡住，打开盖门 H 并顺时针旋转旋钮 H6。将纸张留在接纸架中。[426.xx-428.xx]">
      [x] 页卡住，打开盖门 H 并顺时针旋转旋钮 H6。将纸张留在接纸架中。[426.xx-428.xx]
     </a>
    </p>
    <p class="toc-2-style">
     <a href="message-page-jam-press-latch-area-e-open-adf-top-cover-topic.html#message-page-jam-press-latch-area-e-open-adf-top-cover_sc" title="[x] 页卡住，按下区域 E 处的插销以打开 ADF 的顶部盖板。[28y.xx]">
      [x] 页卡住，按下区域 E 处的插销以打开 ADF 的顶部盖板。[28y.xx]
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="troubleshooting-chapter.html#troubleshooting-chapter_sc" title="疑难解答">
     疑难解答
    </a>
   </p>
   <div id="divd0e20638">
    <p class="toc-2-style">
     <a href="message-cartridge-low-88.xy-topic.html#d0e20641" title="理解打印机消息">
      理解打印机消息
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-printer-not-responding-topic.html#d0e22397" title="解决打印机问题">
      解决打印机问题
     </a>
    </p>
    <p class="toc-2-style">
     <a href="solving-print-problems-group.html#d0e23117" title="解决打印问题">
      解决打印问题
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-copier-does-not-respond-topic.html#d0e25705" title="解决复印问题">
      解决复印问题
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-caller-id-not-shown-topic.html#d0e25997" title="解决传真问题">
      解决传真问题
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-scan-from-a-computer-topic.html#d0e26535" title="解决扫描仪问题">
      解决扫描仪问题
     </a>
    </p>
    <p class="toc-2-style">
     <a href="application-error-has-occurred-topic.html#d0e26997" title="解决主屏幕应用程序问题">
      解决主屏幕应用程序问题
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-embedded-web-server-does-not-open-topic.html#trb-embedded-web-server-does-not-open_sc" title="Embedded Web Server 没有打开">
      Embedded Web Server 没有打开
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-contacting-customer-support-topic.html#trb-contacting-customer-support_sc" title="联系客户支持">
      联系客户支持
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="laser_ug_notices.html#laser_ug_notices_sc" title="注意事项">
     注意事项
    </a>
   </p>
   <div id="divd0e27214">
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e27217" title="产品信息">
      产品信息
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e27234" title="版本注意事项">
      版本注意事项
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#trademarks_sc" title="商标">
      商标
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#licensing-notices_sc" title="许可注意事项">
      许可注意事项
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#noise-emission-levels_sc" title="噪音水平">
      噪音水平
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#product-disposal_sc" title="产品处理">
      产品处理
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#static-sensitivity-notice_sc" title="静电灵敏度注意事项">
      静电灵敏度注意事项
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#energy-star_sc" title="ENERGY STAR">
      ENERGY STAR
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e27491" title="中国 RoHS 计划的信息">
      中国 RoHS 计划的信息
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#temperature-information_sc" title="温度信息">
      温度信息
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e27695" title="激光注意事项">
      激光注意事项
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#laser-advisory-label_sc" title="激光忠告标签">
      激光忠告标签
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#power-consumption_sc" title="能量消耗">
      能量消耗
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#ccc-emc-notice_sc" title="CCC EMC 注意事项">
      CCC EMC 注意事项
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#regulatory-notices-for-telecommunication-terminal-equipment_sc" title="通信终端设备管制通告">
      通信终端设备管制通告
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#regulatory-notices-for-wireless-products_sc" title="无线产品管制通告">
      无线产品管制通告
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#modular-component-notice_sc" title="模块组件注意事项">
      模块组件注意事项
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#exposure-to-radio-frequency-radiation_sc" title="无线频率辐射暴露通告">
      无线频率辐射暴露通告
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#patent-acknowledgment_sc" title="Patent acknowledgment">
      Patent acknowledgment
     </a>
    </p>
   </div>
  </div>
 </div>
</template>
<script>
 import output from './output.json';

const fuzzysort = require('fuzzysort');
const lunr = require("lunr")
require("lunr-languages/lunr.stemmer.support.js")(lunr)
require('lunr-languages/lunr.multi')(lunr)
require("lunr-languages/tinyseg.js")(lunr)
require("lunr-languages/lunr.de.js")(lunr)
require("lunr-languages/lunr.es.js")(lunr)
require("lunr-languages/lunr.fr.js")(lunr)
require("lunr-languages/lunr.it.js")(lunr)
require("lunr-languages/lunr.ja.js")(lunr)
require("lunr-languages/lunr.pt.js")(lunr)

export default {
  name: 'app',
  data() {
    return {
        search: '',
        resultsActual: '',
        list: output,
        resultsCount: 0,
    }
  },

  methods: { queryResults() {

      if (this.search.trim() === ''){
        return  '';
      }
    //   else if(this.search.trim().length < 3){
    //     this.resultsActual = new Array();
    //     this.resultsCount = 0;
    //   }
      else {
        var documents = this.list;

        var idx = lunr(function () {
            this.use(lunr.ja);
            this.use(lunr.multiLanguage('en', 'de', 'es', 'fr', 'it', 'ja', 'pt'))
            this.ref('UUID');
            this.field('title');
            this.field('descFull');
            this.metadataWhitelist = ['position'];

            documents.forEach(function (doc) {
                        this.add(doc)
                    },this);
            });
        

        var searchTerms = this.search.replace(/[`~!#$%^&*()|+\-=?;:'",.<>\{\}\[\]\\/]/gi, ' ').trim().replace(/\s\s+/g, " ");
        // var searchTerms = this.search;
        searchTerms = this.removeStopWords(searchTerms);
        var searchRawTerms = searchTerms;
        // searchTerms  =  searchTerms.split(" ").join(" +");
        // searchTerms = searchTerms.startsWith(" +") ? searchTerms : "+" + searchTerms;

        console.log(searchTerms);
        var results = idx.search(searchTerms);

        console.log (results);

        results = results.map(res => {
            var linkRes =  documents.find(elem => elem.UUID == res.ref);
            var keywords_array = new Array();
            var keywords_arrays = new Array();
            var keywords_arrays_title = new Array();

            Object.keys(res.matchData.metadata).map(kys => {
                var positions_title = res.matchData.metadata[kys].title;
                var positions_desc = res.matchData.metadata[kys].descFull;

                if(typeof positions_title !== 'undefined' ){
                    positions_title.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays_title.push(val[0],val[1]);
                    });
                }

                if(typeof positions_desc !== 'undefined' ){
                    positions_desc.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays.push(val[0],val[1]);
                    });
                }
            });

            

            res.link = linkRes.link;
            res.desc = linkRes.desc;
            res.title = linkRes.title;
            res.full = linkRes.descFull;
            res.titleArray = keywords_arrays_title;
            res.descArray = keywords_arrays;
            keywords_array = keywords_array.filter(function(item, index){ 
                return searchRawTerms.indexOf(item) >= 0;
            });
            var keywords_set = new Set(keywords_array);
            res.keywords = [...keywords_set].toString();
            // res.keywords = ["ramon","joe","gudz"]
            return res;
        });
        
        var existingPagesInResult = new Array();
        

       
        results = results.filter(function(item, index){
                
            if(existingPagesInResult.includes(item.link)){
                
                return false;
            }
            else { 
                existingPagesInResult.push(item.link);
                return true;
            }

            if(res.keywords == ""){
                return false;
            }
        });

        

        console.log (results);
        this.resultsActual = results;
        this.resultsCount = results.length;
      }
    },

    clearResult: function(){
        this.search = "";
        this.resultsActual = undefined;
        this.resultsCount = 0;
        reload("cover.html", "");
       
    },  

    removeStopWords: function(queryString) {
        const stopWords = ['i', 'me', 'my', 'myself', 'we', 'our', 'ours', 'ourselves', 'you', "you're", "you've", "you'll", "you'd", 'your', 'yours', 'yourself', 'yourselves', 
        'he', 'him', 'his', 'himself', 'she', "she's", 'her', 'hers', 'herself', 'it', "it's", 'its', 'itself', 'they', 'them', 'their', 'theirs', 'themselves', 'what', 'which', 
        'who', 'whom', 'this', 'that', "that'll", 'these', 'those', 'am', 'is', 'are', 'was', 'were', 'be', 'been', 'being', 'have', 'has', 'had', 'having', 'do', 'does', 'did', 
        'doing', 'a', 'an', 'the', 'and', 'but', 'if', 'or', 'because', 'as', 'until', 'while', 'of', 'at', 'by', 'for', 'with', 'about', 'against', 'between', 'into', 'through', 
        'during', 'before', 'after', 'above', 'below', 'to', 'from', 'up', 'down', 'in', 'out', 'on', 'off', 'over', 'under', 'again', 'further', 'then', 'once', 'here', 'there', 
        'when', 'where', 'why', 'how', 'all', 'any', 'both', 'each', 'few', 'more', 'most', 'other', 'some', 'such', 'no', 'nor', 'not', 'only', 'own', 'same', 'so', 'than', 'too', 
        'very', 's', 't', 'can', 'will', 'just', 'don', "don't", 'should', "should've", 'now', 'd', 'll', 'm', 'o', 're', 've', 'y', 'ain', 'aren', "aren't", 'couldn', "couldn't", 
        'didn', "didn't", 'doesn', "doesn't", 'hadn', "hadn't", 'hasn', "hasn't", 'haven', "haven't", 'isn', "isn't", 'ma', 'mightn', "mightn't", 'mustn', "mustn't", 'needn', 
         "needn't", 'shan', "shan't", 'shouldn', "shouldn't", 'wasn', "wasn't", 'weren', "weren't", 'won', "won't", 'wouldn', "wouldn't"]

        var cleanQueryString = new Array();
        queryString.split(" ").forEach(word => {
             if(!stopWords.includes(word)) {
                 cleanQueryString.push(word);
             }
        });

        return cleanQueryString.join(" ");
    },
    
  }
}
</script>


// WEBPACK FOOTER //
// src/App.vue